import { useCurrentUserRegions } from "../../../hooks/useCurrentUserRegions.js";
import { useOnClickOutside } from "../../../../../hooks/useOnClickOutside.js";
import { RegionItem } from "./RegionItem.js";
/* empty css                       */
import { useRef } from "react";
import { Button, Icon, Tooltip } from "@therms/atalaya";
import { FaStar } from "react-icons/fa";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useTransitionState } from "react-transition-state";
//#region src/modules/AppWrapper2/components/AppNav/components/RegionPickerMobile.tsx
function RegionPickerMobile({ onCloseRegionPicker }) {
	const { availableRegions, changeCurrentRegion, currentRegion, userPrimaryRegionId } = useCurrentUserRegions();
	const ref = useRef(null);
	const [{ status }, toggle] = useTransitionState({
		mountOnEnter: true,
		preEnter: true,
		timeout: 250,
		unmountOnExit: true
	});
	const isPickerExpanded = status !== "unmounted";
	useOnClickOutside(ref, () => {
		toggle(false);
	});
	if (!currentRegion) return null;
	return /* @__PURE__ */ jsxs("div", {
		ref,
		children: [/* @__PURE__ */ jsx(Button, {
			className: "bg-surface-subtle group text-left",
			fullWidth: true,
			subtle: true,
			onClick: () => {
				toggle();
			},
			children: /* @__PURE__ */ jsxs("div", {
				className: "inline-flex w-full items-center justify-between",
				children: [/* @__PURE__ */ jsx("span", {
					className: "text-color group-hover:text-color group-active:text-color-subtle font-medium transition",
					children: /* @__PURE__ */ jsxs("span", {
						className: "gap-x-xxs flex items-center",
						children: [userPrimaryRegionId === currentRegion.id && /* @__PURE__ */ jsx(Tooltip, {
							className: "inline-flex items-center",
							tooltip: /* @__PURE__ */ jsx("div", {
								className: "min-w-max",
								children: "Primary Region"
							}),
							children: /* @__PURE__ */ jsx(Icon, {
								color: "info",
								Icon: FaStar,
								size: "sm"
							})
						}), /* @__PURE__ */ jsx("span", { children: currentRegion.name })]
					})
				}), /* @__PURE__ */ jsx(Icon, { Icon: isPickerExpanded ? MdExpandLess : MdExpandMore })]
			})
		}), isPickerExpanded && /* @__PURE__ */ jsx("div", {
			className: classnames({
				"regions-menu-collapsed": status === "exiting" || status === "exited" || status === "preEnter",
				"regions-menu-expanded": status === "entering" || status === "entered"
			}, "regions-menu bg-surface-subtle gap-y-xs flex flex-col rounded-md"),
			children: availableRegions.map(({ id, name, timezone }) => /* @__PURE__ */ jsx(RegionItem, {
				id,
				isActive: currentRegion.id === id,
				isPrimary: userPrimaryRegionId === id,
				onClick: () => {
					changeCurrentRegion(id);
					onCloseRegionPicker?.();
				},
				name,
				timezone,
				showTimezoneTime: true
			}, id))
		})]
	});
}
//#endregion
export { RegionPickerMobile };

//# sourceMappingURL=RegionPickerMobile.js.map